import api from '@/apis/di/autoBusinessAPI';
import Crud from '@/stores/crudBaseCache';
var crud = new Crud('autoBusinessCache', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_auto_business',
    field: {
      key: 'auto_business_id',
      // code: 'auto_business_name',
      name: 'auto_business_name',
      quickFollow: 'inactive', // NTLoc-2022/05/06 : thêm key để update trạng thái theo dõi
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  updateItemCombo(context, res) {
    //cập nhật danh sách
    context.commit('updateItem', res);
  },
  insertItemCombo(context, res) {
    //cập nhật danh sách
    context.commit('insertItem', res);
  },
  deleteItemCombo(context, deleted) {
    //Commit thực hiện xóasinp
    context.commit('deleteItems', deleted);
  },
  updateItemQuickFllowCombo(context, res) {
    //Commit thực hiện xóasinp
    context.commit('updateItemQuickFllow', res);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
